import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  static targets = [
    "sportRelatedInjury",
    "contextField",
    "sportSelect",
    "helmetSelect",
    "positionSelect"
  ];

  connect() {
    this.selectElement = document.getElementById("typed_incident_report_actions_taken");
    if (this.selectElement) {
      this.selectElement.addEventListener("change", this.checkSelection.bind(this));
    }

    // Reset selects before Turbo caches the page
    document.addEventListener("turbo:before-cache", this.resetSelects.bind(this));
  }

  disconnect() {
    if (this.selectElement) {
      this.selectElement.removeEventListener("change", this.checkSelection.bind(this));
    }

    document.removeEventListener("turbo:before-cache", this.resetSelects.bind(this));
  }

  toggleLossOfConsciousnessDurationField() {
    const selectedValue = event.target.value;
    const lossOfConsciousnessDuration = document.querySelector(".loss_of_consciousness_duration");

    if (selectedValue === "Yes") {
      this.fadeInElement(lossOfConsciousnessDuration);
    } else {
      this.fadeOutElement(lossOfConsciousnessDuration);
    }
  }

  fadeInElement(element) {
    element.classList.remove("d-none");
    setTimeout(() => {
      element.classList.add("show");
    }, 10);
  }

  fadeOutElement(element) {
    element.classList.remove("show");
    setTimeout(() => {
      element.classList.add("d-none");
      this.resetSelect(element); // Reset selects when hiding
    }, 500);
  }

  checkSelection() {
    const selectedOptions = Array.from(this.selectElement.selectedOptions).map(opt => opt.value);
    if (selectedOptions.includes("Returned to Play") || selectedOptions.includes("Continued to Play")) {
      const modal = new Modal('#rtpModal', {});
      modal.show();
    }
  }

  showRtpRationaleField() {
    const field = document.querySelector('[data-incident-context="rtp_rationale"]');
    if (field) {
      const input = field.querySelector("input, textarea, select");
      if (input) {
        input.setAttribute("required", "required");
      }
      this.fadeInElement(field);
    } else {
      console.error('No element found with data-incident-context="rtp_rationale"');
    }

    const modalElement = document.getElementById("rtpModal");
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  updateSportRelatedOptions() {
    if (!this.hasSportSelectTarget) {
      console.error("Sport select target not found!");
      return;
    }

    const selectedSport = this.sportSelectTarget.value;

    const helmetTag = document.querySelector("#helmets-by-sport");
    const helmetData = JSON.parse(helmetTag.textContent);
    const helmetOptions = helmetData[selectedSport] || helmetData["default"] || [];

    this.helmetSelectTarget.innerHTML = "";

    helmetOptions.forEach(option => {
      this.helmetSelectTarget.append(new Option(option, option));
    });

    this.helmetSelectTarget.size = Math.max(1, helmetOptions.length);

    const positionTag = document.querySelector("#positions-by-sport");
    const positionData = JSON.parse(positionTag.textContent);
    const positionOptions = positionData[selectedSport] || positionData["default"] || [];

    this.positionSelectTarget.innerHTML = "";

    positionOptions.forEach(option => {
      this.positionSelectTarget.append(new Option(option, option));
    });

    this.positionSelectTarget.size = Math.max(1, positionOptions.length);
  }

  toggleFields() {
    if (!this.hasSportRelatedInjuryTarget) return;

    const selectedValue = this.sportRelatedInjuryTarget.value;

    this.contextFieldTargets.forEach((field) => {
      const expectedValue = field.dataset.incidentContext;
      if (expectedValue && ["sport", "non-sport"].includes(selectedValue.toLowerCase())) {
        if (expectedValue.toLowerCase() === selectedValue.toLowerCase()) {
          this.fadeInElement(field);
        } else {
          this.fadeOutElement(field);
        }
      }
    });
  }

  resetForm() {
    const form = this.element.closest("form");
    if (form) {
      form.reset(); // Resets all input fields, checkboxes, radio buttons, and select elements
    }
  }

  // Resets select fields when hiding them
  resetSelect(element) {
    const select = element.querySelector("select");
    if (select) {
      select.value = "";
      if (select.multiple) {
        select.selectedIndex = -1;
      }
    }
  }

  // Reset all select elements before Turbo caches the page
  resetSelects() {
    this.contextFieldTargets.forEach(field => this.resetSelect(field));
    if (this.selectElement) {
      this.selectElement.value = "";
      if (this.selectElement.multiple) {
        this.selectElement.selectedIndex = -1;
      }
    }
  }
}
